import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import { accountLoginLog } from "@/api/account";
import infoList from "@/mixins/infoList";
import timeDateOptions from "../../components/timeList/timeDateOptions.vue";
import { getChannelMap } from "@/utils/dictionary";
import channelOptions from "../../components/serverList/channelOptions.vue";
export default {
  name: "accountLoginLog",
  mixins: [infoList],
  components: {
    channelOptions: channelOptions,
    timeDateOptions: timeDateOptions
  },
  data: function data() {
    return {
      listApi: accountLoginLog,
      openID_value: "",
      roleID_value: "",
      roleName_value: "",
      channelMap: {},
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      searchInfo: {
        openId: "",
        roleId: "",
        roleName: ""
      }
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getChannelMap();
          case 2:
            _this.channelMap = _context.sent;
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    queryEvent: function queryEvent() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.searchInfo.sdate = _this2.timedata[0];
              _this2.searchInfo.edate = _this2.timedata[1];
              _this2.searchInfo.roleId = _this2.roleID_value;
              _this2.searchInfo.openId = _this2.openID_value;
              _this2.searchInfo.roleName = _this2.roleName_value;
              _this2.loading = true;
              _context2.next = 8;
              return _this2.getTableData();
            case 8:
              _this2.loading = false;
              if (!_this2.tableData) {
                _this2.$message({
                  message: "暂无数据"
                });
              } else if (_this2.tableData && _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    //获取到这一行的roleID然后跳转到玩家信息
    goRouterMsg: function goRouterMsg(e) {
      this.$router.push({
        name: "userRoleInfo",
        query: {
          roleId: e
        }
      });
    },
    getChannelLable: function getChannelLable(item) {
      var id = item.channel_id;
      var label = this.channelMap[id] || '??';
      return "".concat(label, "\uFF08").concat(id, "\uFF09");
    }
  }
};